<template>
  <YapMaskedInput
    :name="id"
    :label="placeholder ?? t('dict.search')"
    :v-model="searchQuery"
    :schema="{ name: id, type: 'string', maxLength: 140 }"
    :floating="floating"
    :grouped="grouped"
    :mask-options="inputFormatter"
    left-icon="search-outline"
    clearable
    @update:model-value="debouncedSearch"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { MaskInputOptions } from 'maska';

import { useI18n } from '@/plugins/i18n';
import YapMaskedInput from '@/components/form/YapMaskedInput.vue';

const props = defineProps<{
  id: string;
  placeholder?: string;
  delay?: number;
  floating?: boolean;
  grouped?: boolean;
  inputFormatter?: MaskInputOptions;
}>();

const emits = defineEmits(['search']);

const searchQuery = ref('');

const { t } = useI18n();

const debouncedSearch = useDebounceFn((query: string) => {
  window.scrollTo(0, 0);
  searchQuery.value = query;
  emits('search', query);
}, props.delay ?? 300);
</script>
